import axios, { AxiosResponse } from 'axios';
import Cookies from 'universal-cookie';

import { IDailyDealsResponse } from '../models/daily-deals/i-daily-deals';

import { CookiesKeys } from '../enums/cookies-keys.enum';

export const getDailyDealsService = (signal: AbortSignal): Promise<AxiosResponse<IDailyDealsResponse>> => {
  return axios.get(`/api/v1/trades/daily_deals`, {
    signal,
    headers: {
      'X-CSRFToken': new Cookies().get(CookiesKeys.csrftoken),
    },
  });
};
